import React from "react";
import type { ApolloClient } from "@apollo/client";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";
import { get } from "lodash";

import SimpleModal from "components/SimpleModal";
import { freezeEmployer } from "services/adminService";
import type { FreezeEmployerMutationVariables } from "types/graphql";

interface OwnProps {
  // PropTypes had company as a generic object.isRequired; only `id` is read.
  company: { id?: FreezeEmployerMutationVariables["companyId"] };
  onClose: (clickingOutsideModal?: boolean) => void;
}

type Props = WithApolloClient<OwnProps>;

const FreezeCompanyModal = ({ onClose, company, client }: Props) => {
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [error, setError] = React.useState<string>();

  const freeze = async () => {
    setIsSubmitting(true);
    try {
      await freezeEmployer(
        client as ApolloClient<object>,
        // lodash get returns unknown; companyId is string | number
        get(company, "id") as FreezeEmployerMutationVariables["companyId"]
      );
      onClose();
    } catch (err) {
      setError(
        (err as { message?: string })?.message ||
          "An error occurred while unfreezing the company."
      );
    }
    setIsSubmitting(false);
  };

  return (
    <SimpleModal
      show={true}
      onClose={onClose}
      onSubmit={freeze}
      title="Freeze Company"
      buttonText="Freeze"
      closeButtonText="Cancel"
      showCloseButton={true}
      isXhrRequest={true}
      isFetching={isSubmitting}
      btnDisabled={false}
      error={error}
    >
      <p>
        Are you sure you want to freeze this company? Unfreezing requires admin
        approval.
      </p>
    </SimpleModal>
  );
};

export default withApollo<Props>(FreezeCompanyModal);
